import { render } from "./WallpaperListPage.vue?vue&type=template&id=4e1c8d7c&scoped=true"
import script from "./WallpaperListPage.vue?vue&type=script&lang=js"
export * from "./WallpaperListPage.vue?vue&type=script&lang=js"

import "./WallpaperListPage.vue?vue&type=style&index=0&id=4e1c8d7c&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e1c8d7c"]])

export default __exports__